import { InstrumentName, InstrumentSampleMap } from "../types/sound";

export const instrumentSamples: Record<InstrumentName, InstrumentSampleMap> = {
    "cello": {
        A2: "/sound_lib/cello/A2.ogg",
        A3: "/sound_lib/cello/A3.ogg",
        A4: "/sound_lib/cello/A4.ogg",
        A5: "/sound_lib/cello/A5.ogg",
        "A#2": "/sound_lib/cello/As2.ogg",
        "A#3": "/sound_lib/cello/As3.ogg",
        "A#4": "/sound_lib/cello/As4.ogg",
        "A#5": "/sound_lib/cello/As5.ogg",
        B2: "/sound_lib/cello/B2.ogg",
        B3: "/sound_lib/cello/B3.ogg",
        B4: "/sound_lib/cello/B4.ogg",
        C2: "/sound_lib/cello/C2.ogg",
        C3: "/sound_lib/cello/C3.ogg",
        C4: "/sound_lib/cello/C4.ogg",
        C5: "/sound_lib/cello/C5.ogg",
        "C#2": "/sound_lib/cello/Cs2.ogg",
        "C#3": "/sound_lib/cello/Cs3.ogg",
        "C#4": "/sound_lib/cello/Cs4.ogg",
        "C#5": "/sound_lib/cello/Cs5.ogg",
        D2: "/sound_lib/cello/D2.ogg",
        D3: "/sound_lib/cello/D3.ogg",
        D4: "/sound_lib/cello/D4.ogg",
        D5: "/sound_lib/cello/D5.ogg",
        "D#2": "/sound_lib/cello/Ds2.ogg",
        "D#3": "/sound_lib/cello/Ds3.ogg",
        "D#4": "/sound_lib/cello/Ds4.ogg",
        "D#5": "/sound_lib/cello/Ds5.ogg",
        E2: "/sound_lib/cello/E2.ogg",
        E3: "/sound_lib/cello/E3.ogg",
        E4: "/sound_lib/cello/E4.ogg",
        E5: "/sound_lib/cello/E5.ogg",
        F2: "/sound_lib/cello/F2.ogg",
        F3: "/sound_lib/cello/F3.ogg",
        F4: "/sound_lib/cello/F4.ogg",
        F5: "/sound_lib/cello/F5.ogg",
        "F#2": "/sound_lib/cello/Fs2.ogg",
        "F#3": "/sound_lib/cello/Fs3.ogg",
        "F#4": "/sound_lib/cello/Fs4.ogg",
        "F#5": "/sound_lib/cello/Fs5.ogg",
        G2: "/sound_lib/cello/G2.ogg",
        G3: "/sound_lib/cello/G3.ogg",
        G4: "/sound_lib/cello/G4.ogg",
        G5: "/sound_lib/cello/G5.ogg",
        "G#2": "/sound_lib/cello/Gs2.ogg",
        "G#3": "/sound_lib/cello/Gs3.ogg",
        "G#4": "/sound_lib/cello/Gs4.ogg",
        "G#5": "/sound_lib/cello/Gs5.ogg",
    },
    "e-piano": {
        A1: "/sound_lib/e-piano/A1.ogg",
        A2: "/sound_lib/e-piano/A2.ogg",
        A3: "/sound_lib/e-piano/A3.ogg",
        A4: "/sound_lib/e-piano/A4.ogg",
        A5: "/sound_lib/e-piano/A5.ogg",
        A6: "/sound_lib/e-piano/A6.ogg",
        A7: "/sound_lib/e-piano/A7.ogg",
        "A#1": "/sound_lib/e-piano/As1.ogg",
        "A#2": "/sound_lib/e-piano/As2.ogg",
        "A#3": "/sound_lib/e-piano/As3.ogg",
        "A#4": "/sound_lib/e-piano/As4.ogg",
        "A#5": "/sound_lib/e-piano/As5.ogg",
        "A#6": "/sound_lib/e-piano/As6.ogg",
        "A#7": "/sound_lib/e-piano/As7.ogg",
        B1: "/sound_lib/e-piano/B1.ogg",
        B2: "/sound_lib/e-piano/B2.ogg",
        B3: "/sound_lib/e-piano/B3.ogg",
        B4: "/sound_lib/e-piano/B4.ogg",
        B5: "/sound_lib/e-piano/B5.ogg",
        B6: "/sound_lib/e-piano/B6.ogg",
        B7: "/sound_lib/e-piano/B7.ogg",
        C1: "/sound_lib/e-piano/C1.ogg",
        C2: "/sound_lib/e-piano/C2.ogg",
        C3: "/sound_lib/e-piano/C3.ogg",
        C4: "/sound_lib/e-piano/C4.ogg",
        C5: "/sound_lib/e-piano/C5.ogg",
        C6: "/sound_lib/e-piano/C6.ogg",
        C7: "/sound_lib/e-piano/C7.ogg",
        C8: "/sound_lib/e-piano/C8.ogg",
        "C#1": "/sound_lib/e-piano/Cs1.ogg",
        "C#2": "/sound_lib/e-piano/Cs2.ogg",
        "C#3": "/sound_lib/e-piano/Cs3.ogg",
        "C#4": "/sound_lib/e-piano/Cs4.ogg",
        "C#5": "/sound_lib/e-piano/Cs5.ogg",
        "C#6": "/sound_lib/e-piano/Cs6.ogg",
        "C#7": "/sound_lib/e-piano/Cs7.ogg",
        D1: "/sound_lib/e-piano/D1.ogg",
        D2: "/sound_lib/e-piano/D2.ogg",
        D3: "/sound_lib/e-piano/D3.ogg",
        D4: "/sound_lib/e-piano/D4.ogg",
        D5: "/sound_lib/e-piano/D5.ogg",
        D6: "/sound_lib/e-piano/D6.ogg",
        D7: "/sound_lib/e-piano/D7.ogg",
        "D#1": "/sound_lib/e-piano/Ds1.ogg",
        "D#2": "/sound_lib/e-piano/Ds2.ogg",
        "D#3": "/sound_lib/e-piano/Ds3.ogg",
        "D#4": "/sound_lib/e-piano/Ds4.ogg",
        "D#5": "/sound_lib/e-piano/Ds5.ogg",
        "D#6": "/sound_lib/e-piano/Ds6.ogg",
        "D#7": "/sound_lib/e-piano/Ds7.ogg",
        E1: "/sound_lib/e-piano/E1.ogg",
        E2: "/sound_lib/e-piano/E2.ogg",
        E3: "/sound_lib/e-piano/E3.ogg",
        E4: "/sound_lib/e-piano/E4.ogg",
        E5: "/sound_lib/e-piano/E5.ogg",
        E6: "/sound_lib/e-piano/E6.ogg",
        E7: "/sound_lib/e-piano/E7.ogg",
        F1: "/sound_lib/e-piano/F1.ogg",
        F2: "/sound_lib/e-piano/F2.ogg",
        F3: "/sound_lib/e-piano/F3.ogg",
        F4: "/sound_lib/e-piano/F4.ogg",
        F5: "/sound_lib/e-piano/F5.ogg",
        F6: "/sound_lib/e-piano/F6.ogg",
        F7: "/sound_lib/e-piano/F7.ogg",
        "F#1": "/sound_lib/e-piano/Fs1.ogg",
        "F#2": "/sound_lib/e-piano/Fs2.ogg",
        "F#3": "/sound_lib/e-piano/Fs3.ogg",
        "F#4": "/sound_lib/e-piano/Fs4.ogg",
        "F#5": "/sound_lib/e-piano/Fs5.ogg",
        "F#6": "/sound_lib/e-piano/Fs6.ogg",
        "F#7": "/sound_lib/e-piano/Fs7.ogg",
        G1: "/sound_lib/e-piano/G1.ogg",
        G2: "/sound_lib/e-piano/G2.ogg",
        G3: "/sound_lib/e-piano/G3.ogg",
        G4: "/sound_lib/e-piano/G4.ogg",
        G5: "/sound_lib/e-piano/G5.ogg",
        G6: "/sound_lib/e-piano/G6.ogg",
        G7: "/sound_lib/e-piano/G7.ogg",
        "G#1": "/sound_lib/e-piano/Gs1.ogg",
        "G#2": "/sound_lib/e-piano/Gs2.ogg",
        "G#3": "/sound_lib/e-piano/Gs3.ogg",
        "G#4": "/sound_lib/e-piano/Gs4.ogg",
        "G#5": "/sound_lib/e-piano/Gs5.ogg",
        "G#6": "/sound_lib/e-piano/Gs6.ogg",
        "G#7": "/sound_lib/e-piano/Gs7.ogg",
    },
    "harp": {
        A1: "/sound_lib/harp/A1.ogg",
        A2: "/sound_lib/harp/A2.ogg",
        A3: "/sound_lib/harp/A3.ogg",
        A4: "/sound_lib/harp/A4.ogg",
        A5: "/sound_lib/harp/A5.ogg",
        A6: "/sound_lib/harp/A6.ogg",
        "A#1": "/sound_lib/harp/As1.ogg",
        "A#2": "/sound_lib/harp/As2.ogg",
        "A#3": "/sound_lib/harp/As3.ogg",
        "A#4": "/sound_lib/harp/As4.ogg",
        "A#5": "/sound_lib/harp/As5.ogg",
        "A#6": "/sound_lib/harp/As6.ogg",
        B1: "/sound_lib/harp/B1.ogg",
        B2: "/sound_lib/harp/B2.ogg",
        B3: "/sound_lib/harp/B3.ogg",
        B4: "/sound_lib/harp/B4.ogg",
        B5: "/sound_lib/harp/B5.ogg",
        B6: "/sound_lib/harp/B6.ogg",
        C1: "/sound_lib/harp/C1.ogg",
        C2: "/sound_lib/harp/C2.ogg",
        C3: "/sound_lib/harp/C3.ogg",
        C4: "/sound_lib/harp/C4.ogg",
        C5: "/sound_lib/harp/C5.ogg",
        C6: "/sound_lib/harp/C6.ogg",
        C7: "/sound_lib/harp/C7.ogg",
        "C#1": "/sound_lib/harp/Cs1.ogg",
        "C#2": "/sound_lib/harp/Cs2.ogg",
        "C#3": "/sound_lib/harp/Cs3.ogg",
        "C#4": "/sound_lib/harp/Cs4.ogg",
        "C#5": "/sound_lib/harp/Cs5.ogg",
        "C#6": "/sound_lib/harp/Cs6.ogg",
        "C#7": "/sound_lib/harp/Cs7.ogg",
        D1: "/sound_lib/harp/D1.ogg",
        D2: "/sound_lib/harp/D2.ogg",
        D3: "/sound_lib/harp/D3.ogg",
        D4: "/sound_lib/harp/D4.ogg",
        D5: "/sound_lib/harp/D5.ogg",
        D6: "/sound_lib/harp/D6.ogg",
        D7: "/sound_lib/harp/D7.ogg",
        "D#1": "/sound_lib/harp/Ds1.ogg",
        "D#2": "/sound_lib/harp/Ds2.ogg",
        "D#3": "/sound_lib/harp/Ds3.ogg",
        "D#4": "/sound_lib/harp/Ds4.ogg",
        "D#5": "/sound_lib/harp/Ds5.ogg",
        "D#6": "/sound_lib/harp/Ds6.ogg",
        "D#7": "/sound_lib/harp/Ds7.ogg",
        E1: "/sound_lib/harp/E1.ogg",
        E2: "/sound_lib/harp/E2.ogg",
        E3: "/sound_lib/harp/E3.ogg",
        E4: "/sound_lib/harp/E4.ogg",
        E5: "/sound_lib/harp/E5.ogg",
        E6: "/sound_lib/harp/E6.ogg",
        E7: "/sound_lib/harp/E7.ogg",
        F1: "/sound_lib/harp/F1.ogg",
        F2: "/sound_lib/harp/F2.ogg",
        F3: "/sound_lib/harp/F3.ogg",
        F4: "/sound_lib/harp/F4.ogg",
        F5: "/sound_lib/harp/F5.ogg",
        F6: "/sound_lib/harp/F6.ogg",
        F7: "/sound_lib/harp/F7.ogg",
        "F#1": "/sound_lib/harp/Fs1.ogg",
        "F#2": "/sound_lib/harp/Fs2.ogg",
        "F#3": "/sound_lib/harp/Fs3.ogg",
        "F#4": "/sound_lib/harp/Fs4.ogg",
        "F#5": "/sound_lib/harp/Fs5.ogg",
        "F#6": "/sound_lib/harp/Fs6.ogg",
        "F#7": "/sound_lib/harp/Fs7.ogg",
        G1: "/sound_lib/harp/G1.ogg",
        G2: "/sound_lib/harp/G2.ogg",
        G3: "/sound_lib/harp/G3.ogg",
        G4: "/sound_lib/harp/G4.ogg",
        G5: "/sound_lib/harp/G5.ogg",
        G6: "/sound_lib/harp/G6.ogg",
        G7: "/sound_lib/harp/G7.ogg",
        "G#1": "/sound_lib/harp/Gs1.ogg",
        "G#2": "/sound_lib/harp/Gs2.ogg",
        "G#3": "/sound_lib/harp/Gs3.ogg",
        "G#4": "/sound_lib/harp/Gs4.ogg",
        "G#5": "/sound_lib/harp/Gs5.ogg",
        "G#6": "/sound_lib/harp/Gs6.ogg",
        "G#7": "/sound_lib/harp/Gs7.ogg",
    },
    "piano": {
        A1: "/sound_lib/piano/A1.ogg",
        A2: "/sound_lib/piano/A2.ogg",
        A3: "/sound_lib/piano/A3.ogg",
        A4: "/sound_lib/piano/A4.ogg",
        A5: "/sound_lib/piano/A5.ogg",
        A6: "/sound_lib/piano/A6.ogg",
        A7: "/sound_lib/piano/A7.ogg",
        "A#1": "/sound_lib/piano/As1.ogg",
        "A#2": "/sound_lib/piano/As2.ogg",
        "A#3": "/sound_lib/piano/As3.ogg",
        "A#4": "/sound_lib/piano/As4.ogg",
        "A#5": "/sound_lib/piano/As5.ogg",
        "A#6": "/sound_lib/piano/As6.ogg",
        "A#7": "/sound_lib/piano/As7.ogg",
        B1: "/sound_lib/piano/B1.ogg",
        B2: "/sound_lib/piano/B2.ogg",
        B3: "/sound_lib/piano/B3.ogg",
        B4: "/sound_lib/piano/B4.ogg",
        B5: "/sound_lib/piano/B5.ogg",
        B6: "/sound_lib/piano/B6.ogg",
        B7: "/sound_lib/piano/B7.ogg",
        C1: "/sound_lib/piano/C1.ogg",
        C2: "/sound_lib/piano/C2.ogg",
        C3: "/sound_lib/piano/C3.ogg",
        C4: "/sound_lib/piano/C4.ogg",
        C5: "/sound_lib/piano/C5.ogg",
        C6: "/sound_lib/piano/C6.ogg",
        C7: "/sound_lib/piano/C7.ogg",
        "C#1": "/sound_lib/piano/Cs1.ogg",
        "C#2": "/sound_lib/piano/Cs2.ogg",
        "C#3": "/sound_lib/piano/Cs3.ogg",
        "C#4": "/sound_lib/piano/Cs4.ogg",
        "C#5": "/sound_lib/piano/Cs5.ogg",
        "C#6": "/sound_lib/piano/Cs6.ogg",
        "C#7": "/sound_lib/piano/Cs7.ogg",
        D1: "/sound_lib/piano/D1.ogg",
        D2: "/sound_lib/piano/D2.ogg",
        D3: "/sound_lib/piano/D3.ogg",
        D4: "/sound_lib/piano/D4.ogg",
        D5: "/sound_lib/piano/D5.ogg",
        D6: "/sound_lib/piano/D6.ogg",
        D7: "/sound_lib/piano/D7.ogg",
        "D#1": "/sound_lib/piano/Ds1.ogg",
        "D#2": "/sound_lib/piano/Ds2.ogg",
        "D#3": "/sound_lib/piano/Ds3.ogg",
        "D#4": "/sound_lib/piano/Ds4.ogg",
        "D#5": "/sound_lib/piano/Ds5.ogg",
        "D#6": "/sound_lib/piano/Ds6.ogg",
        "D#7": "/sound_lib/piano/Ds7.ogg",
        E1: "/sound_lib/piano/E1.ogg",
        E2: "/sound_lib/piano/E2.ogg",
        E3: "/sound_lib/piano/E3.ogg",
        E4: "/sound_lib/piano/E4.ogg",
        E5: "/sound_lib/piano/E5.ogg",
        E6: "/sound_lib/piano/E6.ogg",
        E7: "/sound_lib/piano/E7.ogg",
        F1: "/sound_lib/piano/F1.ogg",
        F2: "/sound_lib/piano/F2.ogg",
        F3: "/sound_lib/piano/F3.ogg",
        F4: "/sound_lib/piano/F4.ogg",
        F5: "/sound_lib/piano/F5.ogg",
        F6: "/sound_lib/piano/F6.ogg",
        F7: "/sound_lib/piano/F7.ogg",
        "F#1": "/sound_lib/piano/Fs1.ogg",
        "F#2": "/sound_lib/piano/Fs2.ogg",
        "F#3": "/sound_lib/piano/Fs3.ogg",
        "F#4": "/sound_lib/piano/Fs4.ogg",
        "F#5": "/sound_lib/piano/Fs5.ogg",
        "F#6": "/sound_lib/piano/Fs6.ogg",
        "F#7": "/sound_lib/piano/Fs7.ogg",
        G1: "/sound_lib/piano/G1.ogg",
        G2: "/sound_lib/piano/G2.ogg",
        G3: "/sound_lib/piano/G3.ogg",
        G4: "/sound_lib/piano/G4.ogg",
        G5: "/sound_lib/piano/G5.ogg",
        G6: "/sound_lib/piano/G6.ogg",
        G7: "/sound_lib/piano/G7.ogg",
        "G#1": "/sound_lib/piano/Gs1.ogg",
        "G#2": "/sound_lib/piano/Gs2.ogg",
        "G#3": "/sound_lib/piano/Gs3.ogg",
        "G#4": "/sound_lib/piano/Gs4.ogg",
        "G#5": "/sound_lib/piano/Gs5.ogg",
        "G#6": "/sound_lib/piano/Gs6.ogg",
        "G#7": "/sound_lib/piano/Gs7.ogg",
    },
    "saw-synth": {
        A1: "/sound_lib/saw-synth/A1.ogg",
        A2: "/sound_lib/saw-synth/A2.ogg",
        A3: "/sound_lib/saw-synth/A3.ogg",
        A4: "/sound_lib/saw-synth/A4.ogg",
        A5: "/sound_lib/saw-synth/A5.ogg",
        A6: "/sound_lib/saw-synth/A6.ogg",
        A7: "/sound_lib/saw-synth/A7.ogg",
        "A#1": "/sound_lib/saw-synth/As1.ogg",
        "A#2": "/sound_lib/saw-synth/As2.ogg",
        "A#3": "/sound_lib/saw-synth/As3.ogg",
        "A#4": "/sound_lib/saw-synth/As4.ogg",
        "A#5": "/sound_lib/saw-synth/As5.ogg",
        "A#6": "/sound_lib/saw-synth/As6.ogg",
        "A#7": "/sound_lib/saw-synth/As7.ogg",
        B1: "/sound_lib/saw-synth/B1.ogg",
        B2: "/sound_lib/saw-synth/B2.ogg",
        B3: "/sound_lib/saw-synth/B3.ogg",
        B4: "/sound_lib/saw-synth/B4.ogg",
        B5: "/sound_lib/saw-synth/B5.ogg",
        B6: "/sound_lib/saw-synth/B6.ogg",
        B7: "/sound_lib/saw-synth/B7.ogg",
        C1: "/sound_lib/saw-synth/C1.ogg",
        C2: "/sound_lib/saw-synth/C2.ogg",
        C3: "/sound_lib/saw-synth/C3.ogg",
        C4: "/sound_lib/saw-synth/C4.ogg",
        C5: "/sound_lib/saw-synth/C5.ogg",
        C6: "/sound_lib/saw-synth/C6.ogg",
        C7: "/sound_lib/saw-synth/C7.ogg",
        C8: "/sound_lib/saw-synth/C8.ogg",
        "C#1": "/sound_lib/saw-synth/Cs1.ogg",
        "C#2": "/sound_lib/saw-synth/Cs2.ogg",
        "C#3": "/sound_lib/saw-synth/Cs3.ogg",
        "C#4": "/sound_lib/saw-synth/Cs4.ogg",
        "C#5": "/sound_lib/saw-synth/Cs5.ogg",
        "C#6": "/sound_lib/saw-synth/Cs6.ogg",
        "C#7": "/sound_lib/saw-synth/Cs7.ogg",
        D1: "/sound_lib/saw-synth/D1.ogg",
        D2: "/sound_lib/saw-synth/D2.ogg",
        D3: "/sound_lib/saw-synth/D3.ogg",
        D4: "/sound_lib/saw-synth/D4.ogg",
        D5: "/sound_lib/saw-synth/D5.ogg",
        D6: "/sound_lib/saw-synth/D6.ogg",
        D7: "/sound_lib/saw-synth/D7.ogg",
        "D#1": "/sound_lib/saw-synth/Ds1.ogg",
        "D#2": "/sound_lib/saw-synth/Ds2.ogg",
        "D#3": "/sound_lib/saw-synth/Ds3.ogg",
        "D#4": "/sound_lib/saw-synth/Ds4.ogg",
        "D#5": "/sound_lib/saw-synth/Ds5.ogg",
        "D#6": "/sound_lib/saw-synth/Ds6.ogg",
        "D#7": "/sound_lib/saw-synth/Ds7.ogg",
        E1: "/sound_lib/saw-synth/E1.ogg",
        E2: "/sound_lib/saw-synth/E2.ogg",
        E3: "/sound_lib/saw-synth/E3.ogg",
        E4: "/sound_lib/saw-synth/E4.ogg",
        E5: "/sound_lib/saw-synth/E5.ogg",
        E6: "/sound_lib/saw-synth/E6.ogg",
        E7: "/sound_lib/saw-synth/E7.ogg",
        F1: "/sound_lib/saw-synth/F1.ogg",
        F2: "/sound_lib/saw-synth/F2.ogg",
        F3: "/sound_lib/saw-synth/F3.ogg",
        F4: "/sound_lib/saw-synth/F4.ogg",
        F5: "/sound_lib/saw-synth/F5.ogg",
        F6: "/sound_lib/saw-synth/F6.ogg",
        F7: "/sound_lib/saw-synth/F7.ogg",
        "F#1": "/sound_lib/saw-synth/Fs1.ogg",
        "F#2": "/sound_lib/saw-synth/Fs2.ogg",
        "F#3": "/sound_lib/saw-synth/Fs3.ogg",
        "F#4": "/sound_lib/saw-synth/Fs4.ogg",
        "F#5": "/sound_lib/saw-synth/Fs5.ogg",
        "F#6": "/sound_lib/saw-synth/Fs6.ogg",
        "F#7": "/sound_lib/saw-synth/Fs7.ogg",
        G1: "/sound_lib/saw-synth/G1.ogg",
        G2: "/sound_lib/saw-synth/G2.ogg",
        G3: "/sound_lib/saw-synth/G3.ogg",
        G4: "/sound_lib/saw-synth/G4.ogg",
        G5: "/sound_lib/saw-synth/G5.ogg",
        G6: "/sound_lib/saw-synth/G6.ogg",
        G7: "/sound_lib/saw-synth/G7.ogg",
        "G#1": "/sound_lib/saw-synth/Gs1.ogg",
        "G#2": "/sound_lib/saw-synth/Gs2.ogg",
        "G#3": "/sound_lib/saw-synth/Gs3.ogg",
        "G#4": "/sound_lib/saw-synth/Gs4.ogg",
        "G#5": "/sound_lib/saw-synth/Gs5.ogg",
        "G#6": "/sound_lib/saw-synth/Gs6.ogg",
        "G#7": "/sound_lib/saw-synth/Gs7.ogg",
    },
    "sine-synth": {
        A1: "/sound_lib/sine-synth/A1.ogg",
        A2: "/sound_lib/sine-synth/A2.ogg",
        A3: "/sound_lib/sine-synth/A3.ogg",
        A4: "/sound_lib/sine-synth/A4.ogg",
        A5: "/sound_lib/sine-synth/A5.ogg",
        A6: "/sound_lib/sine-synth/A6.ogg",
        A7: "/sound_lib/sine-synth/A7.ogg",
        "A#1": "/sound_lib/sine-synth/As1.ogg",
        "A#2": "/sound_lib/sine-synth/As2.ogg",
        "A#3": "/sound_lib/sine-synth/As3.ogg",
        "A#4": "/sound_lib/sine-synth/As4.ogg",
        "A#5": "/sound_lib/sine-synth/As5.ogg",
        "A#6": "/sound_lib/sine-synth/As6.ogg",
        "A#7": "/sound_lib/sine-synth/As7.ogg",
        B1: "/sound_lib/sine-synth/B1.ogg",
        B2: "/sound_lib/sine-synth/B2.ogg",
        B3: "/sound_lib/sine-synth/B3.ogg",
        B4: "/sound_lib/sine-synth/B4.ogg",
        B5: "/sound_lib/sine-synth/B5.ogg",
        B6: "/sound_lib/sine-synth/B6.ogg",
        B7: "/sound_lib/sine-synth/B7.ogg",
        C1: "/sound_lib/sine-synth/C1.ogg",
        C2: "/sound_lib/sine-synth/C2.ogg",
        C3: "/sound_lib/sine-synth/C3.ogg",
        C4: "/sound_lib/sine-synth/C4.ogg",
        C5: "/sound_lib/sine-synth/C5.ogg",
        C6: "/sound_lib/sine-synth/C6.ogg",
        C7: "/sound_lib/sine-synth/C7.ogg",
        C8: "/sound_lib/sine-synth/C8.ogg",
        "C#1": "/sound_lib/sine-synth/Cs1.ogg",
        "C#2": "/sound_lib/sine-synth/Cs2.ogg",
        "C#3": "/sound_lib/sine-synth/Cs3.ogg",
        "C#4": "/sound_lib/sine-synth/Cs4.ogg",
        "C#5": "/sound_lib/sine-synth/Cs5.ogg",
        "C#6": "/sound_lib/sine-synth/Cs6.ogg",
        "C#7": "/sound_lib/sine-synth/Cs7.ogg",
        D1: "/sound_lib/sine-synth/D1.ogg",
        D2: "/sound_lib/sine-synth/D2.ogg",
        D3: "/sound_lib/sine-synth/D3.ogg",
        D4: "/sound_lib/sine-synth/D4.ogg",
        D5: "/sound_lib/sine-synth/D5.ogg",
        D6: "/sound_lib/sine-synth/D6.ogg",
        D7: "/sound_lib/sine-synth/D7.ogg",
        "D#1": "/sound_lib/sine-synth/Ds1.ogg",
        "D#2": "/sound_lib/sine-synth/Ds2.ogg",
        "D#3": "/sound_lib/sine-synth/Ds3.ogg",
        "D#4": "/sound_lib/sine-synth/Ds4.ogg",
        "D#5": "/sound_lib/sine-synth/Ds5.ogg",
        "D#6": "/sound_lib/sine-synth/Ds6.ogg",
        "D#7": "/sound_lib/sine-synth/Ds7.ogg",
        E1: "/sound_lib/sine-synth/E1.ogg",
        E2: "/sound_lib/sine-synth/E2.ogg",
        E3: "/sound_lib/sine-synth/E3.ogg",
        E4: "/sound_lib/sine-synth/E4.ogg",
        E5: "/sound_lib/sine-synth/E5.ogg",
        E6: "/sound_lib/sine-synth/E6.ogg",
        E7: "/sound_lib/sine-synth/E7.ogg",
        F1: "/sound_lib/sine-synth/F1.ogg",
        F2: "/sound_lib/sine-synth/F2.ogg",
        F3: "/sound_lib/sine-synth/F3.ogg",
        F4: "/sound_lib/sine-synth/F4.ogg",
        F5: "/sound_lib/sine-synth/F5.ogg",
        F6: "/sound_lib/sine-synth/F6.ogg",
        F7: "/sound_lib/sine-synth/F7.ogg",
        "F#1": "/sound_lib/sine-synth/Fs1.ogg",
        "F#2": "/sound_lib/sine-synth/Fs2.ogg",
        "F#3": "/sound_lib/sine-synth/Fs3.ogg",
        "F#4": "/sound_lib/sine-synth/Fs4.ogg",
        "F#5": "/sound_lib/sine-synth/Fs5.ogg",
        "F#6": "/sound_lib/sine-synth/Fs6.ogg",
        "F#7": "/sound_lib/sine-synth/Fs7.ogg",
        G1: "/sound_lib/sine-synth/G1.ogg",
        G2: "/sound_lib/sine-synth/G2.ogg",
        G3: "/sound_lib/sine-synth/G3.ogg",
        G4: "/sound_lib/sine-synth/G4.ogg",
        G5: "/sound_lib/sine-synth/G5.ogg",
        G6: "/sound_lib/sine-synth/G6.ogg",
        G7: "/sound_lib/sine-synth/G7.ogg",
        "G#1": "/sound_lib/sine-synth/Gs1.ogg",
        "G#2": "/sound_lib/sine-synth/Gs2.ogg",
        "G#3": "/sound_lib/sine-synth/Gs3.ogg",
        "G#4": "/sound_lib/sine-synth/Gs4.ogg",
        "G#5": "/sound_lib/sine-synth/Gs5.ogg",
        "G#6": "/sound_lib/sine-synth/Gs6.ogg",
        "G#7": "/sound_lib/sine-synth/Gs7.ogg",
    },
    "square-synth": {
        A1: "/sound_lib/square-synth/A1.ogg",
        A2: "/sound_lib/square-synth/A2.ogg",
        A3: "/sound_lib/square-synth/A3.ogg",
        A4: "/sound_lib/square-synth/A4.ogg",
        A5: "/sound_lib/square-synth/A5.ogg",
        A6: "/sound_lib/square-synth/A6.ogg",
        A7: "/sound_lib/square-synth/A7.ogg",
        "A#1": "/sound_lib/square-synth/As1.ogg",
        "A#2": "/sound_lib/square-synth/As2.ogg",
        "A#3": "/sound_lib/square-synth/As3.ogg",
        "A#4": "/sound_lib/square-synth/As4.ogg",
        "A#5": "/sound_lib/square-synth/As5.ogg",
        "A#6": "/sound_lib/square-synth/As6.ogg",
        "A#7": "/sound_lib/square-synth/As7.ogg",
        B1: "/sound_lib/square-synth/B1.ogg",
        B2: "/sound_lib/square-synth/B2.ogg",
        B3: "/sound_lib/square-synth/B3.ogg",
        B4: "/sound_lib/square-synth/B4.ogg",
        B5: "/sound_lib/square-synth/B5.ogg",
        B6: "/sound_lib/square-synth/B6.ogg",
        B7: "/sound_lib/square-synth/B7.ogg",
        C1: "/sound_lib/square-synth/C1.ogg",
        C2: "/sound_lib/square-synth/C2.ogg",
        C3: "/sound_lib/square-synth/C3.ogg",
        C4: "/sound_lib/square-synth/C4.ogg",
        C5: "/sound_lib/square-synth/C5.ogg",
        C6: "/sound_lib/square-synth/C6.ogg",
        C7: "/sound_lib/square-synth/C7.ogg",
        C8: "/sound_lib/square-synth/C8.ogg",
        "C#1": "/sound_lib/square-synth/Cs1.ogg",
        "C#2": "/sound_lib/square-synth/Cs2.ogg",
        "C#3": "/sound_lib/square-synth/Cs3.ogg",
        "C#4": "/sound_lib/square-synth/Cs4.ogg",
        "C#5": "/sound_lib/square-synth/Cs5.ogg",
        "C#6": "/sound_lib/square-synth/Cs6.ogg",
        "C#7": "/sound_lib/square-synth/Cs7.ogg",
        D1: "/sound_lib/square-synth/D1.ogg",
        D2: "/sound_lib/square-synth/D2.ogg",
        D3: "/sound_lib/square-synth/D3.ogg",
        D4: "/sound_lib/square-synth/D4.ogg",
        D5: "/sound_lib/square-synth/D5.ogg",
        D6: "/sound_lib/square-synth/D6.ogg",
        D7: "/sound_lib/square-synth/D7.ogg",
        "D#1": "/sound_lib/square-synth/Ds1.ogg",
        "D#2": "/sound_lib/square-synth/Ds2.ogg",
        "D#3": "/sound_lib/square-synth/Ds3.ogg",
        "D#4": "/sound_lib/square-synth/Ds4.ogg",
        "D#5": "/sound_lib/square-synth/Ds5.ogg",
        "D#6": "/sound_lib/square-synth/Ds6.ogg",
        "D#7": "/sound_lib/square-synth/Ds7.ogg",
        E1: "/sound_lib/square-synth/E1.ogg",
        E2: "/sound_lib/square-synth/E2.ogg",
        E3: "/sound_lib/square-synth/E3.ogg",
        E4: "/sound_lib/square-synth/E4.ogg",
        E5: "/sound_lib/square-synth/E5.ogg",
        E6: "/sound_lib/square-synth/E6.ogg",
        E7: "/sound_lib/square-synth/E7.ogg",
        F1: "/sound_lib/square-synth/F1.ogg",
        F2: "/sound_lib/square-synth/F2.ogg",
        F3: "/sound_lib/square-synth/F3.ogg",
        F4: "/sound_lib/square-synth/F4.ogg",
        F5: "/sound_lib/square-synth/F5.ogg",
        F6: "/sound_lib/square-synth/F6.ogg",
        F7: "/sound_lib/square-synth/F7.ogg",
        "F#1": "/sound_lib/square-synth/Fs1.ogg",
        "F#2": "/sound_lib/square-synth/Fs2.ogg",
        "F#3": "/sound_lib/square-synth/Fs3.ogg",
        "F#4": "/sound_lib/square-synth/Fs4.ogg",
        "F#5": "/sound_lib/square-synth/Fs5.ogg",
        "F#6": "/sound_lib/square-synth/Fs6.ogg",
        "F#7": "/sound_lib/square-synth/Fs7.ogg",
        G1: "/sound_lib/square-synth/G1.ogg",
        G2: "/sound_lib/square-synth/G2.ogg",
        G3: "/sound_lib/square-synth/G3.ogg",
        G4: "/sound_lib/square-synth/G4.ogg",
        G5: "/sound_lib/square-synth/G5.ogg",
        G6: "/sound_lib/square-synth/G6.ogg",
        G7: "/sound_lib/square-synth/G7.ogg",
        "G#1": "/sound_lib/square-synth/Gs1.ogg",
        "G#2": "/sound_lib/square-synth/Gs2.ogg",
        "G#3": "/sound_lib/square-synth/Gs3.ogg",
        "G#4": "/sound_lib/square-synth/Gs4.ogg",
        "G#5": "/sound_lib/square-synth/Gs5.ogg",
        "G#6": "/sound_lib/square-synth/Gs6.ogg",
        "G#7": "/sound_lib/square-synth/Gs7.ogg",
    },
    "viola": {
        A3: "/sound_lib/viola/A3.ogg",
        A4: "/sound_lib/viola/A4.ogg",
        A5: "/sound_lib/viola/A5.ogg",
        "A#3": "/sound_lib/viola/As3.ogg",
        "A#4": "/sound_lib/viola/As4.ogg",
        "A#5": "/sound_lib/viola/As5.ogg",
        B3: "/sound_lib/viola/B3.ogg",
        B4: "/sound_lib/viola/B4.ogg",
        B5: "/sound_lib/viola/B5.ogg",
        C3: "/sound_lib/viola/C3.ogg",
        C4: "/sound_lib/viola/C4.ogg",
        C5: "/sound_lib/viola/C5.ogg",
        C6: "/sound_lib/viola/C6.ogg",
        "C#3": "/sound_lib/viola/Cs3.ogg",
        "C#4": "/sound_lib/viola/Cs4.ogg",
        "C#5": "/sound_lib/viola/Cs5.ogg",
        "C#6": "/sound_lib/viola/Cs6.ogg",
        D3: "/sound_lib/viola/D3.ogg",
        D4: "/sound_lib/viola/D4.ogg",
        D5: "/sound_lib/viola/D5.ogg",
        D6: "/sound_lib/viola/D6.ogg",
        "D#3": "/sound_lib/viola/Ds3.ogg",
        "D#4": "/sound_lib/viola/Ds4.ogg",
        "D#5": "/sound_lib/viola/Ds5.ogg",
        "D#6": "/sound_lib/viola/Ds6.ogg",
        E3: "/sound_lib/viola/E3.ogg",
        E4: "/sound_lib/viola/E4.ogg",
        E5: "/sound_lib/viola/E5.ogg",
        E6: "/sound_lib/viola/E6.ogg",
        F3: "/sound_lib/viola/F3.ogg",
        F4: "/sound_lib/viola/F4.ogg",
        F5: "/sound_lib/viola/F5.ogg",
        F6: "/sound_lib/viola/F6.ogg",
        "F#3": "/sound_lib/viola/Fs3.ogg",
        "F#4": "/sound_lib/viola/Fs4.ogg",
        "F#5": "/sound_lib/viola/Fs5.ogg",
        "F#6": "/sound_lib/viola/Fs6.ogg",
        G3: "/sound_lib/viola/G3.ogg",
        G4: "/sound_lib/viola/G4.ogg",
        G5: "/sound_lib/viola/G5.ogg",
        "G#3": "/sound_lib/viola/Gs3.ogg",
        "G#4": "/sound_lib/viola/Gs4.ogg",
        "G#5": "/sound_lib/viola/Gs5.ogg",
    },
};
